module.exports = __webpack_public_path__ + "img/humm_payment.649c6ea1.png";